import { useEffect } from 'react';

export function useOnClickOutside(ref, handler, exceptionRef) {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target) ||
          (exceptionRef && exceptionRef.current && exceptionRef.current.contains(event.target))) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  // Ensure handler is stable by using useCallback in the parent component
  }, [ref, handler, exceptionRef]);
}
